import api from '@/api/axios'
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';


export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null
    },
    getters: {
        authenticated(state) {
            return state.token && state.user
        },
        user(state) {
            return state.user;
        }
    },
    mutations: {
        SET_TOKEN(state, token) { 
            state.token = token;
            localStorage.setItem('token', token);
        },
        SET_USER(state, data) {
            state.user = data;
            localStorage.setItem('user', JSON.stringify(data));
        }
    },
    actions: {
        async signIn({ commit, dispatch }, credentials) {
            const encodedCredentials = btoa('sat@sat:sat23!');
            let response = await api.post('/login', credentials, { headers: { 'Authorization': `Basic ${encodedCredentials}`}});
            if(response.status == 200){

                //commit('SET_USER', response.data.data);

                var tokenBasic = btoa(`${credentials.Usuario}:${credentials.Senha}`);
                dispatch('attempt', tokenBasic);
                dispatch('attemptUser', response.data.data);
                debugger// eslint-disable-line no-debugger 

                var key = "abcdefgh";
                var iv = "hgfedcba";
            
                var encrypted = CryptoJS.DES.encrypt(JSON.stringify(response.data.data), CryptoJS.enc.Utf8.parse(key), {
                    iv: CryptoJS.enc.Utf8.parse(iv),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });

                Cookies.set('nomeUsuarioLogado', encrypted.toString(), { expires: 7, secure: true, sameSite: 'None' }); 

                return response;
            }else{
                
                commit('SET_TOKEN', null)
                commit('SET_USER', null);

                return response;
            }
        },

        async attempt({ commit, state }, token) {

            if (token) {
                commit('SET_TOKEN', token)
            }

            if (!state.token) {
                return
            }

        },

        async attemptUser({ commit, state }, userDate) {

            if (userDate) {
                commit('SET_USER', userDate)
            }

            if (!state.token) {
                return
            }

        },

        async externalSignIn({ commit, dispatch }, encryptedToken) {
            try {
                // Faz POST para a API ASP.NET com o token criptografado
                const response = await api.post('/auth/login', {
                    EncryptedToken: encryptedToken
                }, {
                    withCredentials: true // Importante para enviar/receber cookies da sessão
                });

                if (response.status === 200 && response.data.success) {
                    // Extrai os dados do usuário da resposta
                    const userData = {
                        nomeUsuario: response.data.nomeUsuario || response.data.NomeUsuario,
                        email: response.data.email || response.data.Email,
                        origemCliente: response.data.origemCliente || response.data.OrigemCliente,
                        tipoUsuario: response.data.tipoUsuario || response.data.TipoUsuario,
                        isAdminDNWAYS: response.data.isAdminDNWAYS || response.data.IsAdminDNWAYS || false
                    };

                    // Cria um token básico para manter compatibilidade com o sistema atual
                    const tokenBasic = btoa(`${userData.email}:external_auth`);
                    
                    // Salva o token e dados do usuário
                    dispatch('attempt', tokenBasic);
                    dispatch('attemptUser', userData);

                    // Criptografa e salva no cookie
                    var key = "abcdefgh";
                    var iv = "hgfedcba";
                
                    var encrypted = CryptoJS.DES.encrypt(JSON.stringify(userData), CryptoJS.enc.Utf8.parse(key), {
                        iv: CryptoJS.enc.Utf8.parse(iv),
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7
                    });

                    Cookies.set('nomeUsuarioLogado', encrypted.toString(), { expires: 7, secure: true, sameSite: 'None' });

                    return response;
                } else {
                    commit('SET_TOKEN', null);
                    commit('SET_USER', null);
                    return response;
                }
            } catch (error) {
                commit('SET_TOKEN', null);
                commit('SET_USER', null);
                throw error;
            }
        }
    }
};
